import * as React from 'react';
import { Terminal } from 'xterm';
import { bind } from '../Utils/Bind';

export interface ITermOptions {
    cursorBlink?: boolean;
    cols: number;
    rows: number;
    scrollback?: number;
    tabStopWidth?: number;
}
export interface ITermProps {
    onData(data: string): void;
    options?: ITermOptions;
    className?: string;
}
export interface IXtermState {
    isFocused: boolean;
}

export class Term extends React.Component<ITermProps> {
    public constructor(props: ITermProps) {
        super(props);

        this.term = new Terminal(this.props.options);
        //this.xterm.on('focus', this.focusChanged.bind(this, true));
        //this.xterm.on('blur', this.focusChanged.bind(this, false));
        //this.xterm.on('resize', this.scrollChanged);
        this.term.onData(this.props.onData);
    }

    public componentDidMount() {
        if (this.container) this.term.open(this.container, true);
    }

    public componentDidUpdate() {
        const options = this.props.options as any;
        if (options && this.term) {
            for (const key in options) {
                if (options[key]) this.term.setOption(key, options[key]);
            }
        }
    }

    public componentWillUnmount() {
        if (this.term) {
            this.term.dispose();
            delete this.term;
        }
    }

    public render() {
        return <div ref={this.setContainer} className={this.props.className} />;
    }

    public write(data: string) {
        if (this.term) this.term.write(data);
    }

    @bind
    private setContainer(r: HTMLDivElement | null) {
        this.container = r;
    }

    private term?: any;
    private container: HTMLDivElement | null = null;
}
